export default {
  api: {
    denied: "You do not have permission to do this"
  }
}
